import React from 'react';
import { Form } from 'react-final-form';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { WoltModal } from 'modules/brand/components/venue-group/AddEditVenueGroupModal/styles';

import { EditModalContent } from './EditModalContent';
import { VenueSelectItem, VenueSelectorForm, VenueRowProps } from './types';

type VenueSelectorProps<T> = {
  rowRenderer: (props: VenueRowProps<T>) => React.ReactNode;
  isModalOpen: boolean;
  selectedVenueIds: string[];
  venueSelectItems: VenueSelectItem<T>[];
  setIsModalOpen(isModalOpen: boolean): void;
  onUpdate?(venueIds: string[]): void;
};

const StyledWoltModal = styled(WoltModal)`
  display: flex;
  flex-direction: column;
  min-width: 800px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    min-width: auto;
    width: 98vw;
  }
`;

export const VenueSelector = <T,>({
  rowRenderer,
  isModalOpen,
  selectedVenueIds,
  venueSelectItems,
  setIsModalOpen,
  onUpdate,
}: VenueSelectorProps<T>) => {
  const handleSubmit = (venueIds: string[]) => {
    onUpdate?.(venueIds);
    setIsModalOpen(false);
  };

  return (
    <Form<VenueSelectorForm>
      onSubmit={values => handleSubmit(values.venueIds)}
      initialValues={{ venueIds: selectedVenueIds }}
    >
      {({ form, handleSubmit }) => (
        <StyledWoltModal
          isOpen={isModalOpen}
          onRequestClose={() => {
            setIsModalOpen(false);
            form.reset();
          }}
        >
          <EditModalContent
            venueSelectItems={venueSelectItems}
            onUpdate={handleSubmit}
            rowRenderer={rowRenderer}
            onClose={() => {
              setIsModalOpen(false);
              form.reset();
            }}
          />
        </StyledWoltModal>
      )}
    </Form>
  );
};
